import { DeleteIcon, Search2Icon } from "@chakra-ui/icons";
import {
  Box,
  Button,
  Checkbox,
  Flex,
  Td,
  Tooltip,
  Tr,
  Wrap,
  Text,
  IconButton,
} from "@chakra-ui/react";
import CustomInput from "components/common/customInput/CustomInput";
import { useState } from "react";
import { FaFilePdf, FaPlus } from "react-icons/fa";
import { isActiveUser, levels, roles, userPermission } from "../utils/constant";
import { MdEmail } from "react-icons/md";

const UserApproval = ({
  index,
  values,
  setFieldValue,
  type,
  isDisabled,
  setDeletedApproavals,
  remove,
  generateLevels,
  data,
  isLoading,
  selectModes,
  debouncedLoadOptions,
}: any) => {
  const [selectMode, setSelectMode] = useState(selectModes || "select-async");

  const loadOptions = (
    inputValue: string,
    callback: (options: any[]) => void
  ) => {
    debouncedLoadOptions(inputValue, callback);
  };

  const handleTypeChange = (
    index: number,
    type: string,
    isChecked: boolean
  ) => {
    console.log("type change", index, type, isChecked);
    const currentTypes = values.approvals[index].userPermission || [];
    const newTypes = isChecked
      ? [...currentTypes, type]
      : currentTypes.filter((t: string) => t !== type);
    setFieldValue(`approvals[${index}].userPermission`, newTypes);
  };

  return (
    <Tr key={index} overflow="auto">
      <Td w={{ base: "320px", lg: "400px" }}>
        <Flex columnGap={2}>
          {selectMode === "select-async" ? (
            <CustomInput
              type="select-async"
              name={`approvals[${index}].username`}
              value={values.approvals[index]?.username || ""}
              onChange={(e) => {
                setFieldValue(`approvals[${index}].username`, e);
              }}
              isClear={true}
              getOptionLabel={(option: any) => option.email}
              getOptionValue={(option: any) => option.id}
              loadOptions={loadOptions}
              options={data}
              loading={isLoading}
              placeholder="Search..."
              disabled={isDisabled}
              rest={{ minWidth: "120px", width: "350px" }}
              isBoxSelect={true}
            />
          ) : (
            <CustomInput
              type="text"
              name={`approvals[${index}].username`}
              value={values.approvals[index]?.username || ""}
              onChange={(e) => {
                setFieldValue(`approvals[${index}].username`, e.target.value);
              }}
              placeholder="Use email id"
              disabled={isDisabled}
              rest={{
                width: { base: "10rem", lg: "100%" },
              }}
            />
          )}
          <Tooltip
            hasArrow
            label={
              selectMode === "select-async" ? "Add new" : "Search Existing"
            }
            placement="left"
          >
            <Button
              aria-label=""
              display="none"
              bg="teal.400"
              color="white"
              _hover={{ bg: "teal.500" }}
              onClick={() => {
                setSelectMode(
                  selectMode === "select-async" ? "text" : "select-async"
                );
                setFieldValue(
                  `approvals[${index}].selectMode`,
                  selectMode === "select-async" ? "text" : "select-async"
                );
                setFieldValue(`approvals[${index}].username`, undefined);
              }}
              ml={5}
              h="38px"
              mt="8px"
              isDisabled={isDisabled}
            >
              {selectMode === "select-async" ? <FaPlus /> : <Search2Icon />}
            </Button>
          </Tooltip>
        </Flex>
      </Td>

      <Td w="180px">
        <CustomInput
          type="select"
          name={`approvals[${index}].role`}
          value={values.approvals[index]?.role || ""}
          placeholder="Role"
          options={roles}
          onChange={(e) => {
            setFieldValue(`approvals[${index}].role`, e);
            if (e.value === "admin") {
              setFieldValue(`approvals[${index}].level`, roles[0]);
            } else {
              setFieldValue(`approvals[${index}].level`, levels[0]);
            }
          }}
          rest={{ width: "180px" }}
          disabled={isDisabled}
          isBoxSelect={true}
        />
      </Td>
      <Td w="180px">
        <CustomInput
          type="select"
          name={`approvals[${index}].level`}
          value={values.approvals[index]?.level || ""}
          placeholder="Level"
          options={
            values.approvals[index]?.role?.value === "admin"
              ? [roles[0]]
              : generateLevels(values.levels)
          }
          onChange={(e) => setFieldValue(`approvals[${index}].level`, e)}
          rest={{ width: "180px" }}
          disabled={isDisabled}
          isBoxSelect={true}
        />
      </Td>
      <Td>
        <CustomInput
          type="select"
          name={`approvals[${index}].isActive`}
          value={values.approvals[index]?.isActive || ""}
          placeholder="Active User"
          options={isActiveUser}
          onChange={(e) => setFieldValue(`approvals[${index}].isActive`, e)}
          rest={{ width: "130px" }}
          disabled={isDisabled}
          isBoxSelect={true}
        />
      </Td>
      <Td w={"130px"}>
        <CustomInput
          placeholder="Enter the Designation"
          type="text"
          name={`approvals[${index}].designation`}
          value={values.approvals[index]?.designation || ""}
          onChange={(e) =>
            setFieldValue(`approvals[${index}].designation`, e.target.value)
          }
          rest={{
            width: { base: "10rem", lg: "180px" },
          }}
          disabled={isDisabled}
        />
      </Td>
      <Td whiteSpace="nowrap" position="relative">

        <Flex gap={4} align="center">
          {/* Download Checkbox */}
          <Flex align="center" gap={2} color="red.400">
            <Checkbox
              key="download"
              colorScheme="teal"
              isChecked={
                values?.approvals[index]?.userPermission?.includes("download") || false
              }
              onChange={(e) =>
                handleTypeChange(index, "download", e.target.checked)
              }
              isDisabled={isDisabled}
            >
              <Tooltip
                label="Download Document"
                hasArrow
                portalProps={{ appendToParentPortal: true }}
              >
                <span>
                  <FaFilePdf size="18px" />
                </span>
              </Tooltip>
            </Checkbox>
          </Flex>
          <Flex align="center" gap={2} color="green.500">
            <Checkbox
              key="mail"
              colorScheme="teal"
              isChecked={
                values?.approvals[index]?.userPermission?.includes("mail") || false
              }
              onChange={(e) =>
                handleTypeChange(index, "mail", e.target.checked)
              }
              isDisabled={isDisabled}
            >
              <Tooltip
                label="Send mail with attachment"
                hasArrow
                portalProps={{ appendToParentPortal: true }}
              >
                <span>
                  <MdEmail size="20px" />
                </span>
              </Tooltip>
            </Checkbox>
          </Flex>
        </Flex>
      </Td>
      <Td w={{ base: "320px", lg: "130px" }} display="none">
        <Box
          display={
            values.approvals[index].username?.isText === 1
              ? undefined
              : selectMode === "select-async"
                ? "none"
                : values.approvals[index]?.addNew === 1
                  ? ""
                  : "none"
          }
        >
          <CustomInput
            placeholder="Enter the Password"
            type="password"
            name={`approvals[${index}].password`}
            value={values.approvals[index]?.password || ""}
            onChange={(e) =>
              setFieldValue(`approvals[${index}].password`, e.target.value)
            }
            rest={{
              width: { base: "10rem", lg: "180px" },
            }}
            disabled={
              isDisabled || (type === "edit" && values.approvals[index]?.user)
            }
          />
        </Box>
      </Td>

      <Td>
        <Flex gap={2}>
          <Tooltip label="Delete Approval" hasArrow placement="left">
            <IconButton
              aria-label="Delete"
              size="sm"
              variant={"outline"}
              colorScheme="red"
              icon={<DeleteIcon />}
              onClick={() => {
                if (setDeletedApproavals) {
                  if (values.approvals[index]?.user)
                    setDeletedApproavals((prev: any) => [
                      ...prev,
                      values.approvals[index],
                    ]);
                }
                remove(index);
              }}
            />
          </Tooltip>
        </Flex>
        {/* <Flex gap={2}>
          <Tooltip label="Delete Approval" hasArrow placement="left">
            <Button
              size={"sm"}
              type="button"
              colorScheme="red"
              variant="outline"
              onClick={() => {
                if (setDeletedApproavals) {
                  if (values.approvals[index]?.user)
                    setDeletedApproavals((prev: any) => [
                      ...prev,
                      values.approvals[index],
                    ]);
                }
                remove(index);
              }}
              h="38px"
              mt="8px"
              isDisabled={isDisabled}
            >
              <DeleteIcon />
            </Button>
          </Tooltip>
        </Flex> */}
      </Td>
    </Tr>
  );
};

export default UserApproval;
